import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReportRegistration = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 67,
	height: 61,
	fill: "none",
	viewBox: "0 0 67 61",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 55,
			height: 49,
			x: 11.4,
			y: 11.3,
			fill: "#4A5B50",
			stroke: "#AAFBB2",
			rx: 4.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11.5,
			cy: 10.8,
			r: 10.7,
			fill: "#FFAB00"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M7.9 7.7c0-1 .4-1.9 1-2.5.8-.6 1.7-.8 2.9-.8.7 0 1.4 0 2 .4.5.2 1 .6 1.2 1 .3.5.4 1 .4 1.6 0 .7-.1 1.3-.5 1.8-.3.4-.7.7-1.2.9.6.2 1 .6 1.4 1 .4.6.5 1.2.5 2 0 .6-.1 1.2-.4 1.7a3 3 0 0 1-1.3 1.2c-.6.2-1.3.4-2 .4-1.3 0-2.2-.3-3-1-.8-.5-1.2-1.4-1.2-2.6h2.2c0 .5.2 1 .5 1.2.3.3.8.5 1.4.5.5 0 1-.2 1.2-.4.3-.4.5-.8.5-1.2 0-.7-.2-1.1-.6-1.4-.4-.3-1-.4-1.9-.4h-.5V9.2h.5c1.5 0 2.3-.5 2.3-1.5 0-.4-.2-.8-.4-1-.3-.3-.7-.4-1.2-.4s-.9.1-1.2.4c-.2.2-.4.6-.4 1H7.9Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 20.2,
			height: 3.2,
			x: 39,
			y: 40.1,
			fill: "#AAFBB2",
			rx: 1.6
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 20.2,
			height: 3.2,
			x: 39,
			y: 28.2,
			fill: "#fff",
			rx: 1.6
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 20.2,
			height: 3.2,
			x: 39,
			y: 34,
			fill: "#fff",
			rx: 1.6
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#AAFBB2",
			d: "M28.5 27.8a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 10a6 6 0 0 0-4.8 2.4 6.5 6.5 0 0 0 9.6 0 6 6 0 0 0-4.8-2.4Zm0-7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z",
			opacity: .3
		})
	]
});
export default SvgReportRegistration;
